import { ToastCustom } from "@components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";
import {
	vehicleDocumentPresignedUrl,
	vehicleDocumentUpload,
} from "../services";

export const useVehicleDocumentUpload = (onClose: () => void) => {
	const queryClient = useQueryClient();

	const vehicleDocumentUploadMutation = useMutation({
		mutationFn: vehicleDocumentUpload,
		onSuccess: (_, variables) => {
			onClose();
			const title = variables?.documentId
				? "Documento editado com sucesso!"
				: "Documento adicionado com sucesso!";
			const description = variables?.documentId
				? "Seu documento já está atualizado e pronto para ser consultado."
				: "Seu documento já está disponível para ser consultado.";

			toast(
				ToastCustom({
					description,
					title,
					variant: "success",
				})
			);

			queryClient.invalidateQueries({
				queryKey: ["vehicle-documents-current"],
			});
			queryClient.invalidateQueries({
				queryKey: ["vehicle-documents-history"],
			});
		},
		onError: (error) => {
			if (error instanceof AxiosError) {
				const errorData = error.response?.data;
				if (errorData?.error?.errors?.length > 0 || errorData?.error?.detail) {
					const errorMessages =
						errorData?.error?.errors[0] || errorData?.error?.detail;
					toast(ToastCustom({ description: errorMessages, title: "Erro" }));
					return;
				}
			}
			toast(
				ToastCustom({
					description: "Erro ao atualizar documento",
					title: "Erro",
				})
			);
		},
	});
	const vehicleDocumentPresignedUrlMutation = useMutation({
		mutationFn: vehicleDocumentPresignedUrl,
		onSuccess: (data, variables) => {
			const { vehicleId } = variables;

			vehicleDocumentUploadMutation.mutate({
				vehicleId,
				fileName: variables.fileName,
				type: variables.type,
				...(variables.file && { fileKey: data.filePath }),
				...(variables.paymentDate && { paymentDate: variables.paymentDate }),
				...(variables.renewalDate && { renewalDate: variables.renewalDate }),
				...(variables.description && { description: variables.description }),
				...(variables.documentId && { documentId: variables.documentId }),
			});
			// queryClient.invalidateQueries({ queryKey: [VEHICLE_DOCUMENT_QUERY_KEY] });
		},
		onError: (error) => {
			if (error?.message) {
				toast(ToastCustom({ description: error?.message, title: "Erro" }));
			}
		},
	});

	return vehicleDocumentPresignedUrlMutation;
};
